module.exports = __webpack_public_path__ + "assets/a1ffe1138c8719d7157327c23179e922.woff2";